export default __webpack_public_path__ + "static/media/poppins-semibold.435ac39c.svg";